module.exports = __webpack_public_path__ + "static/media/logo-humani-negativo.1733aa0e.svg";